export const AssetsFromInsert = {
  flow: 'y',
  gap: 'Z',
  CaptionTitle: {
    Text: {
      text: '{{ editor.panel.assets | polyglot }}'
    }
  }
}
